import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import {
    Menu,
    MenuItem,
    MenuList,
    MenuPopover,
    MenuTrigger,
} from '@fluentui/react-components';
import { ArrowSync20Regular, DataTrending20Regular, SignOut20Regular } from '@fluentui/react-icons';
import { apiService } from '@/api/apiService';
import { signOut, switchAccount } from '@/auth/authActions';
import PanelUserCard from '@/coral/components/Panels/UserCard';
import { UserInfo } from '@/models';

interface UserMenuProps {
    userInfo: UserInfo | null;
}

const UserMenu: React.FC<UserMenuProps> = ({ userInfo }) => {
    const { instance } = useMsal();
    const navigate = useNavigate();
    const clientId = window.appConfig?.CLIENT_ID ?? '';
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        let active = true;
        apiService
            .getIsAdmin()
            .then((result) => active && setIsAdmin(result))
            .catch(() => active && setIsAdmin(false));
        return () => {
            active = false;
        };
    }, []);

    const handleSwitchAccount = async () => {
        await switchAccount(instance, clientId);
    };

    const handleSignOut = async () => {
        await signOut(instance);
    };

    const handleTriggerKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            event.currentTarget.click();
        }
    };

    return (
        <Menu>
            <MenuTrigger disableButtonEnhancement>
                <div onKeyDown={handleTriggerKeyDown} role="button" tabIndex={0}>
                    <PanelUserCard
                        alias={userInfo?.user_email}
                        name={userInfo?.user_first_last_name || 'Guest'}
                        size={32}
                    />
                </div>
            </MenuTrigger>
            <MenuPopover>
                <MenuList>
                    {isAdmin && (
                        <MenuItem
                            icon={<DataTrending20Regular />}
                            onClick={() => navigate('/admin/usage')}
                        >
                            Usage insights
                        </MenuItem>
                    )}
                    <MenuItem icon={<ArrowSync20Regular />} onClick={handleSwitchAccount}>
                        Switch account
                    </MenuItem>
                    <MenuItem icon={<SignOut20Regular />} onClick={handleSignOut}>
                        Sign out
                    </MenuItem>
                </MenuList>
            </MenuPopover>
        </Menu>
    );
};

export default UserMenu;
